<script>
import {Tabs} from 'iview'

var ResponsiveObserver = null

// supported ssr
if (typeof window !== 'undefined') {
    const module = require('responsive-observer')
    ResponsiveObserver = module.default
}

export default {
    name: 'v-tab-data-grid',
    components: {
        Tabs
    },
    props: {
        value: {
            type: String
        }
    },
    provide () {
        return {
            tab: this
        }
    },
    data () {
        return {
            tabs: [],
            cache: {},
            isMobile: false,
            isDesktop: false,
            isPad: false
        }
    },
    watch: {
        value: {
            immediate: true,
            handler  (val, old) {
                if (old !== val) this.showTab(val)
            }
        }
    },
    render (h) {
        const { value, renderItems, $slots, isDesktop } = this
        this.cache[value] = true
        return (
            <div class="tab-data-grid" style={{height: isDesktop ? '100%' : ''}}>
                <Tabs value={value} onInput={this.onTabChange}>
                    {$slots.default}
                </Tabs>
            </div>
        )
    },
    methods: {
        select (reload) {
            this.tabs.forEach(tab => {
                if (this.value === tab.name || this.cache[tab.name]) {
                    tab.select(reload)
                }
            })
        },
        add (item) {
            if (this.tabs.indexOf(item) === -1) this.tabs.push(item)
            if (this.value === item.name) this.showTab(item.name)
        },
        pop (item) {
            this.tabs.splice(this.tabs.indexOf(item), item)
        },
        showTab (name) {
            const currentTabIndex = this.tabs.findIndex(t => t.name === name)
            if (currentTabIndex !== -1) this.tabs[currentTabIndex].show = true
        },
        onTabChange (tab) {
            this.cache[tab] = true
            this.showTab(tab)
            this.$emit('input', tab)
        }
    },
    mounted () {
        if (ResponsiveObserver) {
            this.observer = new ResponsiveObserver()
            this.observer.subscribe(screens => {
                this.screens = screens
                let isDesktop = screens.lg
                let isMobile = !isDesktop && screens.xs
                let isPad = !isDesktop && screens.sm
                this.isDesktop = isDesktop
                this.isMobile = isMobile
                this.isPad = isPad
            })
        }
    },
    beforeDestroy () {
        if (this.observer) {
            this.observer.unsubscribe()
        }
    }
}
</script>

<style lang="less">
@import '../color.less';
.tab-data-grid {
    .ivu-tabs {
        height: 100%;
    }
    .ivu-tabs-bar {
        margin-bottom: 12px;
        &:not(.dis-hover){
            &:hover {box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);}
        }
    }
    .ivu-tabs-nav .ivu-tabs-tab-active {
        color: @primary!important;
    }
    .ivu-tabs-tab:hover {
        color: @primary!important;
    }
    .ivu-tabs-ink-bar {
        background: @primary!important;
    }
    .ivu-tabs-nav-wrap {
        background: #fff;
        border-radius: 4px;
        padding: 0 20px;
    }
    .ivu-tabs-content {
        height: calc(~'100% - 49px')!important;
    }
    &-badge-label {
        position: relative;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/framework/data-grid/tab.vue